import templateUrl from "emun.auth/choose-retailer/choose-retailer-prompt.htm";
import controller from "emun.auth/choose-retailer/choose-retailer.controller";
import open from "webmodals/open";

export default ({
  size = "md",
  backdrop = true,
  keyboard = true,
  token,
  resetId,
  id,
  userAuthId,
  title = "Choose Retailer"
}) =>
  open({
    size,
    backdrop,
    keyboard,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title,
      request: () => ({ resetId, token, id, userAuthId })
    }
  }).result;
